import { Create } from "react-admin";
import PositionSaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreatePositions = () => {
  return (
    <Create
      title="Създаване на позиция"
      actions={<BackButtonToolbar />}
    >
      <PositionSaveForm />
    </Create>
  );
};
export default CreatePositions;
